import { Link } from "react-router-dom";

const ManifestoStrip = () => (
  <section className="bg-ink text-cream py-24 md:py-28">
    <div className="container mx-auto px-6 text-center max-w-3xl">
      <span className="text-[11px] tracking-[0.22em] uppercase text-cream/45 font-semibold">— About Diet of Happiness —</span>
      <p className="font-marquee text-3xl md:text-5xl font-light leading-[1.2] mt-6 mb-8">
        Real happiness does not come from what we have, but from{" "}
        <span className="italic text-terracotta font-normal">who we are.</span>
      </p>
      <p className="text-cream/55 text-base mb-8">Finally, a diet worth sticking to. Since 2018.</p>
      <Link to="/about" className="text-terracotta hover:text-cream transition-colors text-sm tracking-wide font-medium">
        Read the full story →
      </Link>
    </div>
  </section>
);

export default ManifestoStrip;
